export default "__VITE_ASSET__CHxJ1aCg__"